import type { Signal } from '@angular/core';
import { InjectionToken } from '@angular/core';
import type { Observable } from 'rxjs';

import type { ComparisonTableRow } from '../../features/feature-comparison/models/comparison-table-row.model';
import type { TableQuery } from '../../shared/components/generic-table/models/table-query.model';

export interface TableDataResponse<T> {
  readonly data: readonly T[];
  readonly totalRecords: number;
}
import type { LineChartConfig } from '../../shared/echarts/models/chart-types';

export type FeatureComparisonSelectOption = { label: string; value: string };

export interface FeatureComparisonClient {
  readonly featureFilters: Signal<FeatureComparisonSelectOption[]>;
  readonly comparisonTimePeriodOptions: Signal<FeatureComparisonSelectOption[]>;
  readonly comparisonAuditOptions: Signal<FeatureComparisonSelectOption[]>;
  readonly comparisonMethodOptions: Signal<FeatureComparisonSelectOption[]>;
  readonly comparisonFavoritesOptions: Signal<FeatureComparisonSelectOption[]>;
  readonly filterFavoritesOptions: Signal<FeatureComparisonSelectOption[]>;
  readonly medicationOptions: Signal<FeatureComparisonSelectOption[]>;
  readonly clinicalUnitOptions: Signal<FeatureComparisonSelectOption[]>;
  readonly serviceDeptOptions: Signal<FeatureComparisonSelectOption[]>;
  readonly patientNameOptions: Signal<FeatureComparisonSelectOption[]>;
  readonly patientIdOptions: Signal<FeatureComparisonSelectOption[]>;
  readonly employeeOptions: Signal<FeatureComparisonSelectOption[]>;
  readonly employeeIdOptions: Signal<FeatureComparisonSelectOption[]>;
  readonly employeeJobRoleOptions: Signal<FeatureComparisonSelectOption[]>;
  readonly shiftOptions: Signal<FeatureComparisonSelectOption[]>;
  readonly fteStatusOptions: Signal<FeatureComparisonSelectOption[]>;

  getComparisonTableRows(query: TableQuery): Observable<TableDataResponse<ComparisonTableRow>>;
  getFeatureLabel(featureId: string): string;
  getLineChartConfig(
    featureIds: string[],
    options?: { dateRange?: { start: Date; end: Date }; metricLabel?: string }
  ): LineChartConfig | null;
}

export const FEATURE_COMPARISON_CLIENT = new InjectionToken<FeatureComparisonClient>(
  'FEATURE_COMPARISON_CLIENT'
);
